import React from 'react';
import cardstyles from "./teamcards.module.css"

const ChooseCards = (props) => {
    return (
        <> 
            <div className={cardstyles.singleCard}>
                <img src={props.img} alt={props.alt} />
                    <h2>{props.name}</h2>
                    <h2>{props.position}</h2>
                <div className={cardstyles.logo}>               
                    <a href={props.whatsapp} target="blank"><i class="fab fa-whatsapp"></i></a>               
                    <a href={props.facebook} target="blank"><i class="fab fa-facebook"></i></a>
                    <a href={props.linkedin} target="blank"><i class="fab fa-linkedin"></i></a>               
                </div>
            </div>
        </>
    );
}
 
 
export default ChooseCards;